import { render, staticRenderFns } from "./NlpWhySatoshiIcon1.vue?vue&type=template&id=332f5662"
import script from "./NlpWhySatoshiIcon1.vue?vue&type=script&lang=js"
export * from "./NlpWhySatoshiIcon1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports